import React, { useState, useEffect } from 'react';
import ArrowBackIosNewRoundedIcon from '@mui/icons-material/ArrowBackIosNewRounded';
import ArrowForwardIosRoundedIcon from '@mui/icons-material/ArrowForwardIosRounded';
import './Calendar.css'; // Assurez-vous d'ajouter un fichier CSS pour le style

const Calendar = ({ selectedDate, onDateChange }) => {
  const [dates, setDates] = useState([]);
  const [startDate, setStartDate] = useState(new Date(selectedDate));

  useEffect(() => {
    updateDates(startDate);
  }, [startDate]);

  const updateDates = (start) => {
    const newDates = [];
    for (let i = 0; i < 7; i++) {
      const date = new Date(start);
      date.setDate(start.getDate() + i);
      newDates.push(date);
    }
    setDates(newDates);
  };

  const handleDateClick = (date) => {
    onDateChange(date);
  };

  const isSelected = (date) => {
    return selectedDate.toDateString() === date.toDateString();
  };

  const handlePreviousWeek = () => {
    const newStartDate = new Date(startDate);
    newStartDate.setDate(startDate.getDate() - 7);
    setStartDate(newStartDate);
    onDateChange(newStartDate); // Sélectionne la première date de la nouvelle semaine
  };

  const handleNextWeek = () => {
    const newStartDate = new Date(startDate);
    newStartDate.setDate(startDate.getDate() + 7);
    setStartDate(newStartDate);
    onDateChange(newStartDate); // Sélectionne la première date de la nouvelle semaine
  };

  const isCurrentWeek = () => {
    const today = new Date();
    return startDate.toDateString() === today.toDateString();
  };

  return (
    <div className="calendar-container">
      {!isCurrentWeek() && (
        <button onClick={handlePreviousWeek} className="nav-button">
          <ArrowBackIosNewRoundedIcon />
        </button>
      )}
      <div className="calendar">
        {dates.map((date, index) => (
          <button
            key={index}
            onClick={() => handleDateClick(date)}
            className={`date-button ${isSelected(date) ? 'selected' : ''}`}
          >
            <div className="day">{date.toLocaleDateString('fr-FR', { weekday: 'short' })}</div>
            <div className="date">{date.getDate()}</div>
            <div className="month">{date.toLocaleDateString('fr-FR', { month: 'short' })}</div>
          </button>
        ))}
      </div>
      <button onClick={handleNextWeek} className="nav-button">
        <ArrowForwardIosRoundedIcon />
      </button>
    </div>
  );
};

export default Calendar;